<template>
    <div>
        <div class="level">
            <div class="level-left">
                <h2 class="title is-size-5">{{ headline }}</h2>
            </div>
            <div class="level-right">
                <button class="button is-primary" @click.prevent="openModal(null)">Opret</button>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <List
                    v-if="items.length > 0"
                    table-classes="table is-fullwidth"
                    :columns="columns"
                    :data="items"
                    :page-length="50"
                    :rows-clickable="false"
                    :default-order="{ col: 'name', dir: 'asc' }"
                    :search="search"
                    @search="onSearch"
                >
                    <template slot="column-actions" slot-scope="{ row }">
                        <a class="button is-small" @click.stop="openModal(row)" title="Rediger">
                            <span class="icon">
                                <i class="fas fa-edit"/>
                            </span>
                        </a>
                    </template>
                </List>
                <span v-else class="list-empty">Ingen standard beskrivelser fundet</span>
            </div>
        </div>

        <DefaultDescriptionModal
            :active="modalOpen"
            :selected-item="modalSelectedItem"
            @closed="closeModal"
            @updated="updated"
            @created="created"
            @deleted="deleted"
        />
    </div>
</template>

<script>
import DefaultDescriptionModal from "./components/DefaultDescriptionModal.vue";
import List from "@/elements/list";

export default {
    components: {
        DefaultDescriptionModal,
        List,
    },
    props: {
        headline: String,
        tab: String,
    },
    data() {
        return {
            items: [],
            modalOpen: false,
            modalSelectedItem: null,
            search: '',
            columns: [
                { name: 'name', title: 'Titel', sortable: true, searchable: true },
                {
                    name: 'actions',
                    title: '',
                    sortable: false,
                    searchable: false,
                    classes: () => 'has-text-right',
                    width: '100px'
                },
            ],
        }
    },
    computed: {
        filtersActive() {
            return this.search !== '';
        }
    },
    methods: {
        onSearch(value) {
            this.search = value
            this.updateUrlParams()
        },
        reset() {
            this.search = ''
            this.updateUrlParams()
            this.updateList()
        },
        updateUrlParams() {
            let params = {
                tab: this.tab,
            };

            if (this.search) {
                params.search = this.search
            }

            this.$router.push({ query: params })
        },
        openModal(selectedItem = null) {
            this.modalSelectedItem = selectedItem
            this.modalOpen = true
        },
        closeModal() {
            this.modalOpen = false
            this.modalSelectedItem = null
        },
        updateList() {
            window.axios.get('/api/default-descriptions')
                .then(({ data }) => {
                    this.items = data
                });
        },
        updated(documentGroup) {
            this.items = this.items.map((item) => {
                if (item.id === documentGroup.id) {
                    return documentGroup
                }
                return item
            })
            this.closeModal();
        },
        created(documentGroup) {
            this.items.push(documentGroup)
            this.closeModal();
        },
        deleted(documentGroup) {
            this.items = this.items.filter((item) => item.id !== documentGroup.id)

            this.closeModal();
        },
    },
    mounted() {
        let params = new URLSearchParams(window.location.search)
        this.search = params.get('search') || ''

        this.updateList()
    },
};
</script>
